export function toFloat(value: string): number {
    return parseFloat(value.replace(',', '.'));
}

export function tryToBoolean(value: string): boolean | string {
    if (value === 'false' || value === 'true') {
        return value === 'true';
    }

    return value;
}

export function emptyStringToNull<T>(value: T): T | null {
    if (value === '') {
        return null;
    }

    return value;
}

export function toStringOrEmpty(value: unknown): string {
    return typeof value === 'string' ? value : '';
}
